import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import useTranslate from '@/hooks/use-translate'
import { CommandBarKeycap } from './CommandBarKeycap'
import { commandBarFooterSx } from './commandBar.styles'

export const CommandBarFooter = () => {
  const { t } = useTranslate('commandBar')

  return (
    <Box sx={commandBarFooterSx}>
      <Stack direction="row" spacing={1} alignItems="center">
        <span>{t('footerSelect')}</span>
        <CommandBarKeycap label="↑" />
        <CommandBarKeycap label="↓" />
        <span>{t('footerOpen')}</span>
        <CommandBarKeycap label="Enter" />
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <span>{t('footerClose')}</span>
        <CommandBarKeycap label="Esc" />
      </Stack>
    </Box>
  )
}
